import InputText from "./text";
import InputAmount from "./amount";
import InputPercentage from "./percentage";
import InputCheckbox from "./checkbox";
import InputSelect from "./select";
import InputTextarea from "./textarea";
import InputDate from "./date";
import InputDateTime from "./datetime";
import InputPassword from "./password";
import SelectWithSearch from "./selectWithSearch";
import Editor from "./editor";

import BasicForm from "./form";

//import InputTextarea from './textarea'
//import InputPorcentaje from './porcentaje'
//import InputColor from './color'
//import InputImporte from './importe'
//import InputSelect from './select'

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

export {
    BasicForm,
    InputText,
    InputAmount,
    InputPassword,
    InputPercentage,
    InputCheckbox,
    InputTextarea,
    InputDate,
    InputDateTime,
    InputSelect,
    SelectWithSearch,
    Editor,
    _filter,
    /*    InputSelect,
    InputPorcentaje,
    InputImporte,
    InputColor,
    InputTextarea,*/
};
